import React from "react";

import { Flex, Box, P, Button } from "ui-components";
import { buttonThemes } from "ui-components/theme";
import { gotoUrl } from "utils/helpers";
import FormattedMessage from "components/FormattedMessage";

const _imageStyle = {
  width: 250,
  mt: 40
};

const _messageStyle = {
  mt: 57,
  mx: 20,
  textAlign: "center !important",
  fontWeight: "bold"
};

const backgroundColor = `${buttonThemes?.blue?.color} !important`;
const hoverColor = `${buttonThemes?.blue?.hoverColor} !important`;
const _buttonStyle = {
  background: backgroundColor,
  color: "#FFF",
  borderColor: backgroundColor,
  minWidth: "10rem !important",
  py: 12,
  borderRadius: 23,
  ":hover": {
    background: hoverColor,
    borderColor: hoverColor
  }
};

const MaintenanceSignup = ({ errorPagesConfig }) => {
  const config = errorPagesConfig?.["maintenance_signup"] || {};
  const errorImage = config.image || "/assets/images/500-robot.png";
  const imageStyle = { ...(config.imageStyle || {}), ..._imageStyle };
  const imageAlt = config.imageAlt || "maintenance_signup";
  const message = config.message || "maintenance_signup_message";
  const messageStyle = { ...(config.messageStyle || {}), ..._messageStyle };
  const buttonText = config.buttonText;
  const buttonStyle = { ...(config.buttonStyle || {}), ..._buttonStyle };
  const redirectUrl = config.configUrl || "/circles1/sa_delivery";

  const handleRedirectOnClick = () => {
    gotoUrl(redirectUrl, true, { relaunch: true }, false, false, true);
  };

  return (
    <Flex alignItems="center" flexDirection="column">
      <Box sx={imageStyle}>
        <img alt={imageAlt} src={errorImage} width="100%" height="auto" />
      </Box>
      <P sx={messageStyle}>
        <FormattedMessage html id={message} />
      </P>
      <Box sx={{ mt: 20 }}>
        <Button sx={buttonStyle} onClick={handleRedirectOnClick}>
          {buttonText || <FormattedMessage id="retry" />}
        </Button>
      </Box>
    </Flex>
  );
};

export default MaintenanceSignup;
